import { useNavigate, useLocation } from 'react-router-dom';

interface UserCreatedState {
  user: {
    username: string;
    email: string;
    firstName: string;
    lastName: string;
    companyName?: string;
    role: string;
  };
  password?: string;
  passwordOption: string;
  sendWelcomeEmail: boolean;
}

export default function UserCreated() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as UserCreatedState;

  return (
    <div className='min-h-screen bg-slate-900 flex items-center justify-center p-4'>
      <div className='bg-slate-800 rounded-lg p-8 max-w-md w-full border border-white/10'>
        <div className='text-center'>
          <div className='w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4'>
            <svg
              className='w-8 h-8 text-green-400'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M5 13l4 4L19 7'
              />
            </svg>
          </div>

          <h1 className='text-2xl font-bold text-white mb-2'>User Created Successfully!</h1>

          {state?.user && (
            <div className='bg-slate-700/50 rounded-lg p-4 mb-6 text-left'>
              <h3 className='text-lg font-medium text-slate-200 mb-3'>User Details</h3>
              <div className='space-y-2 text-sm'>
                <div>
                  <span className='text-slate-400'>Name:</span>{' '}
                  <span className='text-white'>
                    {state.user.firstName} {state.user.lastName}
                  </span>
                </div>
                <div>
                  <span className='text-slate-400'>Username:</span>{' '}
                  <span className='text-white'>{state.user.username}</span>
                </div>
                <div>
                  <span className='text-slate-400'>Email:</span>{' '}
                  <span className='text-white'>{state.user.email}</span>
                </div>
                <div>
                  <span className='text-slate-400'>Role:</span>{' '}
                  <span className='text-white capitalize'>{state.user.role}</span>
                </div>
                {state.user.companyName && (
                  <div>
                    <span className='text-slate-400'>Company:</span>{' '}
                    <span className='text-white'>{state.user.companyName}</span>
                  </div>
                )}
              </div>

              {state.password && state.passwordOption === 'temporary' && (
                <div className='mt-4 p-3 bg-yellow-500/20 border border-yellow-500/30 rounded'>
                  <p className='text-yellow-200 text-sm font-medium mb-2'>Temporary Password:</p>
                  <code className='text-yellow-100 text-sm font-mono bg-slate-800 px-2 py-1 rounded'>
                    {state.password}
                  </code>
                  <p className='text-yellow-200 text-xs mt-2'>
                    The user will be required to change this password on first login.
                  </p>
                </div>
              )}
            </div>
          )}

          <div className='flex gap-3 justify-center'>
            <button
              className='bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition-colors'
              onClick={() => navigate('/admin/users/create')}
            >
              Create Another User
            </button>
            <button
              className='bg-slate-600 text-white px-6 py-2 rounded hover:bg-slate-700 transition-colors'
              onClick={() => navigate('/admin/users')}
            >
              View All Users
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
